<nav
  class="fixed inset-y-0 left-0 z-[100] flex h-screen w-4/6 max-w-xs -translate-x-full flex-col bg-brand-primary-pure transition-all duration-300 ease-in-out aria-expanded:visible aria-expanded:translate-x-0 aria-hidden:invisible md:hidden"
  [attr.aria-expanded]="!isCollapsed()"
  [attr.aria-hidden]="isCollapsed()"
  [attr.aria-label]="'Navegação do Meu Mundo'"
>
  <div class="flex items-center justify-between px-5 py-3 md:hidden">
    <img
      src="assets/images/my-world-logo-white.webp"
      alt="Logo Meu Mundo"
      class="w-28 object-contain"
    />

    <button
      class="inline-flex text-white transition-colors duration-150 hover:text-brand-primary-lighter"
      (click)="toggleCollapse.emit()"
    >
      <ng-icon name="featherX" size="32" />
    </button>
  </div>

  <ul class="flex w-full flex-col gap-2 md:w-fit md:flex-row md:gap-7">
    @for (page of navPages; track $index) {
      <li class="h-12 font-roboto text-base/5 font-bold md:h-fit">
        <a
          [routerLink]="[]"
          [fragment]="page.link"
          class="flex size-full cursor-pointer items-center px-5 text-white transition-all duration-75"
          [ngClass]="{
            'bg-brand-primary-dark': activeSection() === page.link,
            'hover:bg-brand-primary-light/50': activeSection() !== page.link
          }"
        >
          {{ page.pageName }}
        </a>
      </li>
    }
  </ul>
</nav>

<nav
  class="hidden gap-5 bg-white py-4 md:z-50 md:flex md:items-center md:justify-center md:shadow-sm"
>
  <ul class="flex items-center justify-center gap-7">
    @for (page of navPages; track $index) {
      <li class="h-12 font-roboto text-base/5 font-bold md:h-fit">
        <a
          [routerLink]="[]"
          [fragment]="page.link"
          class="flex size-full cursor-pointer items-center border-b-2 pb-0.5 transition-all duration-150"
          [ngClass]="{
            'border-brand-primary-pure text-brand-primary-pure':
              activeSection() === page.link,
            'border-transparent text-neutral-low-medium hover:text-brand-primary-pure':
              activeSection() !== page.link
          }"
        >
          {{ page.pageName }}
        </a>
      </li>
    }
  </ul>
</nav>

<div
  class="fixed inset-0 z-[90] transition-opacity duration-300 md:pointer-events-none md:hidden"
  [ngClass]="{
    'pointer-events-auto bg-neutral-low-dark/75': !isCollapsed(),
    'pointer-events-none bg-transparent': isCollapsed()
  }"
  (click)="toggleCollapse.emit()"
></div>
